/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyResourcesResponse {
    getFixupPrototypeFunction() { return CostAnomalyResourcesResponse.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyResourcesResponse>): CostAnomalyResourcesResponse {
        let obj = Object.assign(new CostAnomalyResourcesResponse(), model);
        CostAnomalyResourcesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyResourcesResponse>): CostAnomalyResourcesResponse {
        if (!model) return null;
        return CostAnomalyResourcesResponse.newInstance(<CostAnomalyResourcesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyResourcesResponse) {
        if (!obj) return;

        models.CostAnomalyResourcesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyResourcesResponse): boolean {
        Object.setPrototypeOf(obj, CostAnomalyResourcesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.details) {
            for (let val of this.details) {
                models.CostAnomalySummaryResource.fixupPrototype(val);
            }
        }
    }

    /**
     * Cost Anomaly resource wise daily summary
     */
    details: Array<models.CostAnomalySummaryResource>;

}
